import React, { Component } from 'react';
import clsx from 'clsx';
import ChevronIcon from 'assets/icons/ChevronIcon';
import { remCalc } from '../../../util/style-util';
import { gray3 } from '../../../styles/style-constants';
import { FONT_GSS_FUTURA, FONT_GSS_PRINT_WIDE } from 'themes/default';
import { translate } from 'translations/translator';
import withStyles from 'components/@layout/withStyles';

type Props = {
  label: string;
  openByDefault?: boolean;
  openFilter: string;
  setOpenFilter: any;
  selectedTags: Array<any>;
  filterGroupValues: Array<any>;
  children: any;
  contentClasses?: string;
  applySectionClass?: any;
  classes: any;
};

const translateResources = key => translate('resources', key);
const translateCommon = key => translate('common', key);
class FilterDropDown extends Component<Props> {
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  public wrapperRef: any = null;
  public parentWrapperRef: any = null;

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  setParentWrapperRef = node => {
    this.parentWrapperRef = node;
  };
  handleClick = () => {
    const { label, openFilter, setOpenFilter } = this.props;
    setOpenFilter(openFilter !== label ? label : '');
  };
  handleClickOutside = event => {
    //Mouse click is not on the dropdown menu
    if (this.wrapperRef && !this.wrapperRef?.contains(event.target)) {
      //And mouse click is not in the parent pulldown -- if the click is there, it will
      //call handleClick on its own
      if (this.parentWrapperRef && !this.parentWrapperRef.contains(event.target)) {
        this.handleClick();
      }
    }
  };

  renderContent() {
    const { openFilter, label, classes } = this.props;
    const { content } = classes;

    return openFilter === label ? (
      <div ref={this.setWrapperRef} className={content}>
        {this.props.children}
      </div>
    ) : null;
  }

  render() {
    const { openFilter, label, selectedTags, filterGroupValues, classes, applySectionClass } =
      this.props;
    const { dropdown, enclosingDiv, head, headOpen, rotate180, icon, iconContainer } = classes;
    const isOpen = openFilter === label;

    let filterText = translateCommon('allOption');
    if (selectedTags) {
      if (label === translateResources('resourceType')) {
        const relevantTags = selectedTags.filter(selectedFilter =>
          filterGroupValues.find(filter => filter.id === selectedFilter.id)
        );
        if (relevantTags.length > 0) {
          filterText =
            relevantTags.length === 1 ? relevantTags[0].value : relevantTags.length.toString();
        }
      } else {
        filterText = selectedTags.reduce((acc, selectedFilter) => {
          const matchingFilter = filterGroupValues.find(filter => filter.id === selectedFilter.id);
          if (matchingFilter !== undefined) {
            if (acc === translateCommon('allOption')) {
              return (acc = matchingFilter.value);
            } else {
              return (acc = acc + ', ' + matchingFilter.value);
            }
          }
          return acc;
        }, filterText);
      }
    }

    return (
      <div ref={this.setParentWrapperRef} className={enclosingDiv}>
        {this.props.label}
        <div className={this.props.contentClasses || dropdown}>
          <section
            className={clsx(head, isOpen && headOpen, applySectionClass)}
            onClick={this.handleClick}
          >
            <span>{filterText}</span>
            <div className={iconContainer}>
              <div className={clsx(icon, isOpen && rotate180)}>
                <ChevronIcon />
              </div>
            </div>
          </section>
          {this.renderContent()}
        </div>
      </div>
    );
  }
}

const styles = {
  enclosingDiv: {
    paddingTop: '10px',
    paddingBottom: '15px',
    color: '#202020',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '18px',
    fontFamily: FONT_GSS_FUTURA
  },
  dropdown: {
    width: remCalc(186),
    userSelect: 'none',
    border: '2px solid #000000',
    paddingLeft: '10px',
    PaddingRight: '10px',
    backgroundColor: '#FFFFFF',
    marginRight: '10px',
    marginTop: '2px',
    marginBottom: '3px',
    marginLeft: '-2px',
    borderRadius: '8px'
  },
  head: {
    position: 'relative',
    fontFamily: FONT_GSS_PRINT_WIDE,
    fontSize: remCalc(14),
    padding: `${remCalc(10)} ${remCalc(10)} 0 0`,
    width: '95%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    color: gray3
  },
  content: {
    position: 'absolute',
    padding: '1rem',
    border: '1px solid #000000',
    backgroundColor: '#FFFFFF',
    zIndex: 5,
    marginLeft: '-11px'
  },
  rotate180: {
    transform: 'rotate(0deg) !important'
  },
  iconContainer: {
    paddingBottom: remCalc(10),
    width: '14px'
  },
  icon: {
    transition: 'transform 0.1s ease-in-out',
    transform: 'rotate(180deg)'
  }
};

export default withStyles(styles)(FilterDropDown) as any;
